import { useEffect, useMemo } from "react";
import dayjs from "dayjs";
import { useAppDispatch, useAppSelector } from "../store";
import { fetchAppointments, userAppointments, userAppointmentsLoading } from "../store/slices/user";

const useAppointments = () => {
  const data = useAppSelector(userAppointments);
  const loading = useAppSelector(userAppointmentsLoading);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchAppointments());
  }, []);

  const appointments = useMemo(() => {
    return data ? data.filter((appointment) => {
      return dayjs(appointment.start_at).add(50, "minute").isAfter(dayjs());
    }) : [];
  }, [data]);

  return {
    appointments,
    loading
  };
};

export default useAppointments;
